import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Input, DatePicker, Space, Select } from 'antd';
import { SaveOutlined } from "@ant-design/icons";
import axios from "axios";
import { toast } from "react-toastify";
import { Btns, FormContainer } from "./styled";
import dayjs from 'dayjs';


export function ModalTratamentoDp({ isOpen, onClose, idClient, fetchPendentesData, fetchEmitidasData }) {

    const dateFormat = 'YYYY-MM-DD';
    const [atualDate, setAtualDate] = useState(dayjs().format(dateFormat));
    const [isIdClient, setIsIdClient] = useState("");

    const [newData, setNewData] = useState({
        data: "",
        tipo: "",
        valor: "",
        situacaoId: "",
        situacaoNome: "",
        descricao: "",
        usuarioCadastro: "",
        dataCadastro: "",
        usuarioAlteracao: "",
        dataAlteracao: "",
    })

    useEffect(() => {
        setAtualDate(dayjs().format(dateFormat));
        consultarData(idClient);
        setIsIdClient(idClient);
    }, []);

    const consultarData = async (idClient) => {
        const url = "/portal/rest/contador/recurso/apontamento/consultar";
        const param = {
            id: idClient
        };

        try {
            const response = await axios.post(url, param, { withCredentials: true });
            setNewData(prevState => ({
                ...prevState,
                data: response.data.dataReferencia,
                tipo: response.data.tipo.nome,
                valor: response.data.valor,
                situacaoId: response.data.tipo.nome,
                situacaoNome: response.data.situacao.nome,
                descricao: response.data.tipo.nome,
                usuarioCadastro: response.data.usuarioCadastro.id,
                dataCadastro: response.data.dataCadastro === null ? "data alteração" : convertTimestampToDate(response.data.dataCadastro),
                usuarioAlteracao: response.data.usuarioSituacao.id,
                dataAlteracao: response.data.dataAlteracao === null ? "data alteração" : convertTimestampToDate(response.data.dataAlteracao),
            }));

        } catch {
            toast.error("Erro ao buscar os dados.");
        }
    }

    const postData = async () => {
        const url = "/portal/rest/contador/recurso/apontamento/situacao/atualizar";
        const param = {
            id: isIdClient,
            situacao: {
                id: newData.situacaoId
            }
        }

        try {
            const response = await axios.post(url, param, { withCredentials: true });
            onClose();
            fetchPendentesData();
            fetchEmitidasData();
        } catch {
            toast.error("não foi possível salvar os dados.");
        }
    }

    const convertTimestampToDate = (timestamp) => {
        return new Date(parseInt(timestamp, 10));
    };

    const handleCancel = () => {
        onClose();
    };

    const clearForm = () => {
        setNewData({
            codigo: "",
            id: "",
            senha: "",
            site: "",
            tipo: ""
        });
    };

    const changeDescricao = (e) => {
        setNewData({
            ...newData,
            descricao: e.target.value
        })
    }

    const onChangeSituacao = (value, nome) => {
        setNewData({
            ...newData,
            situacaoId: value,
            situacaoNome: nome
        })

    }

    return (
        <>
            <Modal
                title="Tratamento de Atendimento"
                open={isOpen}
                onOk={postData}
                onCancel={handleCancel}
                width={1100}
            >
                <FormContainer>
                    <div className="form-content">
                        <Form.Item
                            className="form-item"
                            name="data"
                        >
                            <label className="label" tmlFor="">Data:</label>
                            <Input disabled placeholder={newData.data || "Id"} value={newData.data} />
                        </Form.Item>
                        <Form.Item
                            className="form-item"
                            name="cliente"
                        >
                            <label className="label" htmlFor="">Tipo:</label>
                            <Input disabled placeholder={newData.tipo || "tipo"} value={newData.tipo} />
                        </Form.Item>
                        <Form.Item
                            className="form-item"
                            name="valor"
                        >
                            <label className="label" tmlFor="">Valor:</label>
                            <Input disabled placeholder={newData.valor || "valor"} value={newData.valor} />
                        </Form.Item>
                        <Form.Item
                            className="form-item"
                            name="situação"
                            value={newData.situacaoNome}
                            defaultValue={newData.situacaoNome}
                            style={{ width: "200px" }}
                        >
                            <label className="label" htmlFor="">Situação:</label>
                            <Select
                                showSearch
                                placeholder={newData.situacaoNome}
                                value={newData.nome}
                                onChange={onChangeSituacao}
                            >
                                <Select.Option value="">Selecionar</Select.Option>
                                <Select.Option value="P">Pendente</Select.Option>
                                <Select.Option value="F">Fechada</Select.Option>

                            </Select>
                        </Form.Item>
                    </div>

                    <div className="form-content">
                        <Form.Item
                            className="form-item"
                            name="decricao"

                        >
                            <label className="label" htmlFor="">Descrição:</label>
                            <Input.TextArea disabled style={{ width: "1000px", height: "130px", display: "flex" }} onChange={changeDescricao} placeholder={newData.descricao} value={newData.descricao} />
                        </Form.Item>
                    </div>

                    <div className="form-content">

                        <Form.Item
                            className="form-item"
                            name="usuarioCadastro"
                        >
                            <label className="label" htmlFor="">Usuário cadastro:</label>
                            <Input style={{ width: "auto" }} disabled placeholder={newData.usuarioCadastro} value={newData.usuarioCadastro} />
                        </Form.Item>
                        <Form.Item
                            className="form-item"
                            name="dataCadastro"
                        >
                            <label className="label" htmlFor="">Data cadastro:</label>
                            <Input disabled placeholder={newData.dataCadastro || "data cadastro"} value={newData.dataCadastro} />
                        </Form.Item>

                        <Form.Item
                            className="form-item"

                            name="usuarioAlteracao"
                        >
                            <label className="label" htmlFor="">Usuário alteração:</label>
                            <Input style={{ width: "auto" }} disabled placeholder={newData.usuarioAlteracao} value={newData.usuarioAlteracao} />
                        </Form.Item>
                        <Form.Item
                            className="form-item"
                            name="dataAlteracao"
                        >
                            <label className="label" htmlFor="">Data alteração:</label>
                            <Input disabled placeholder={newData.dataAlteracao || "dataAlteracao"} value={newData.dataAlteracao} />
                        </Form.Item>
                    </div>
                </FormContainer>
            </Modal>
        </>
    );
};

export default ModalTratamentoDp;